import { useEffect, useRef, useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { scrollers, scrollContent } from "@/lib/useMainScroll";

// Translucent floating ball (bottom-right) to jump to the top / bottom of the page area and its table boxes.
export function ScrollBall({ target }) {
  const [st, setSt] = useState({ can: false, top: true, bottom: false });
  const last = useRef("");
  useEffect(() => {
    const el = target.current;
    if (!el) return undefined;
    let raf = 0;
    const upd = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const list = scrollers(el).filter((n) => n.scrollHeight > n.clientHeight + 120);
        const s = { can: list.length > 0, top: list.every((n) => n.scrollTop < 40), bottom: list.every((n) => n.scrollTop + n.clientHeight >= n.scrollHeight - 40) };
        const k = `${s.can}${s.top}${s.bottom}`;
        if (k !== last.current) { last.current = k; setSt(s); }
      });
    };
    upd();
    el.addEventListener("scroll", upd, { passive: true, capture: true });
    const mo = new MutationObserver(upd);
    mo.observe(el, { childList: true, subtree: true });
    window.addEventListener("resize", upd);
    return () => { cancelAnimationFrame(raf); el.removeEventListener("scroll", upd, { capture: true }); mo.disconnect(); window.removeEventListener("resize", upd); };
  }, [target]);
  if (!st.can) return null;
  const btn = "h-10 w-10 flex items-center justify-center text-primary transition-colors hover:bg-primary/15 disabled:opacity-25 disabled:hover:bg-transparent";
  return (
    <div className="fixed bottom-6 right-5 z-40 flex flex-col overflow-hidden rounded-full border border-primary/25 bg-background/40 shadow-lg backdrop-blur-md opacity-60 transition-opacity duration-200 hover:opacity-100"
      data-testid="scroll-ball">
      <button type="button" className={btn} disabled={st.top} onClick={() => scrollContent(target.current, null, "start")} aria-label="Ke atas" data-testid="scroll-top"><ChevronUp className="h-5 w-5" /></button>
      <div className="mx-2 h-px bg-primary/25" />
      <button type="button" className={btn} disabled={st.bottom} onClick={() => scrollContent(target.current, null, "end")} aria-label="Ke bawah" data-testid="scroll-bottom"><ChevronDown className="h-5 w-5" /></button>
    </div>
  );
}
